import { useSelector } from '@xstate/react';
import { useCallback } from 'react';
import { createEmptyActor } from 'xstate';
import { UserContextV2 } from '~/app';
import type { Notification } from '~/types/common/notification';

const emptyActor = createEmptyActor();

export const useUserState = () => {
  const userRef = UserContextV2.useActorRef();
  const state = useSelector(userRef, (snapshot) => snapshot.value);
  const roleCode = useSelector(userRef, (snapshot) => snapshot.context.roleCode);

  return {
    state,
    roleCode,
  };
};

export const useNotificationsRef = () => {
  const userRef = UserContextV2.useActorRef();
  const { notificationsRef } = useSelector(userRef, (s) => s.context);
  const ref = notificationsRef ?? emptyActor;

  const { isOpen, notifications } = useSelector(
    ref,
    (s) =>
      (s as { context?: { isOpen: boolean; notifications: Notification[] } }).context ?? {
        isOpen: false,
        notifications: [],
      }
  );

  const toggleNotificationsOpen = useCallback(() => {
    notificationsRef?.send({ type: 'ON_TOGGLE_PANEL' });
  }, [notificationsRef]);

  return { isOpen, toggleNotificationsOpen, notificationsRef, notifications };
};
